// Auth actions
export const SET_LOGIN_AUTH = 'SET_LOGIN_AUTH';
export const SET_PATIENT_LOGIN_AUTH = 'SET_PATIENT_LOGIN_AUTH';
export const SET_LOGOUT_AUTH = 'SET_LOGOUT_AUTH';
export const SET_PATIENT_LOGOUT_AUTH = 'SET_PATIENT_LOGOUT_AUTH';
export const INITIALIZE_APP = 'INITIALIZE_APP';
export const INITIALIZE_PATIENT_APP = 'INITIALIZE_PATIENT_APP';
export const PATIENT_INFO = 'PATIENT_INFO';
export const BACK_NAVIGATION = 'BACK_NAVIGATION';
export const VIEW_PDF = 'VIEW_PDF';
export const SIGNATURE_ACKNOWLEDGEMENT = 'SIGNATURE_ACKNOWLEDGEMENT';
export const PATIENT_PROCEDURE = 'PATIENT_PROCEDURE';
export const TIME_STAMP = 'TIME_STAMP';
export const SET_TIME = 'SET_TIME';
export const USER_INFO = 'USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const UPDATE_NAVIAGTION_STATUS = 'UPDATE_NAVIAGTION_STATUS';
export const DISABLE_BUTTONS = 'DISABLE_BUTTONS';
export const DISABLE_LINEAND_BUTTON = 'DISABLE_LINEAND_BUTTON';
export const UPDATE_SURGERY_TIMES = 'UPDATE_SURGERY_TIMES';
export const UPDATE_SURGERY_TIMES_CLICKABLE = 'UPDATE_SURGERY_TIMES_CLICKABLE';
export const UPDATE_SURGERY_TIMES_ACTIVE = 'UPDATE_SURGERY_TIMES_ACTIVE';
export const TIMER_ACKNOWLEDGEMENT = 'TIMER_ACKNOWLEDGEMENT';
export const TIMER_MODALITY_ACKNOWLEDGEMENT = 'TIMER_MODALITY_ACKNOWLEDGEMENT';
export const FLASH_ACKNOWLEDGEMENT = 'FLASH_ACKNOWLEDGEMENT';
export const CLOSE_TIMESTAMP = 'CLOSE_TIMEATAMP';
export const CASES_COUNT_ACKNOWLEDGEMENT = 'CASES_COUNT_ACKNOWLEDGEMENT';
export const SNACKBAR_ACKNOWLEDGEMENT = 'SNACKBAR_ACKNOWLEDGEMENT';
export const LOGIN_ERROR_MESSAGE = 'LOGIN_ERROR_MESSAGE';
export const DATE_OF_SERVICE = 'DATE_OF_SERVICE';
export const PATIENT_DATE = "PATIENT_DATE";
export const SELECTED_MODALITY = "SELECTED_MODALITY"
export const IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT = 'IMPERSONATE_USER_REFRESH_ACKNOWLEDGEMENT';
export const IS_PATIENT_DOCUMENT_DETAILS ='IS_PATIENT_DOCUMENT_DETAILS'
export const IMPERSONATE_VIEW_ENABLED = 'IMPERSONATE_VIEW_ENABLED';
export const ANESTHETIC_INFUSION_TIME = 'ANESTHETIC_INFUSION_TIME'
export const ATBR_PDF_ACKNOWLEDGEMENT = 'ATBR_PDF_ACKNOWLEDGEMENT';
export const TIMERMINSEC = 'TIMERMINSEC';
export const PREVIEWATBRTIMESTAMP = 'PREVIEWATBRTIMESTAMP';
export const UPDATEVITALSCOUNT = 'UPDATEVITALSCOUNT';
export const ENABLEMODALITIES = 'ENABLEMODALITIES';
export const SELECTEDDATE = 'SELECTEDDATE';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const PATIENT_DETAILS = 'PATIENT_DETAILS';
export const UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS';
export const SET_OFFLINE_MODE = 'SET_OFFLINE_MODE';
export const SHOW_OFFLINE_TOGGLE_BUTTON = 'SHOW_OFFLINE_TOGGLE_BUTTON';
export const SELECTED_DOUMENT_SUBMISSION_DETAILS_ID = 'SELECTED_DOUMENT_SUBMISSION_DETAILS_ID';
export const SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID = 'SELECTED_DOUMENT_SUBMISSION_DETAILS_CASE_PID';
export const IS_PATIENT_FORM_DETAILS = 'IS_PATIENT_FORM_DETAILS';
export const SET_ACTIVE_PARENT_TAB = 'SET_ACTIVE_PARENT_TAB';
// these are the functions to save and reset the patient form
export const UPDATE_PATIENT_FORM_FIELD = 'UPDATE_PATIENT_FORM_FIELD';
export const SET_PATIENT_FORM_DATA = 'SET_PATIENT_FORM_DATA';
export const CLEAR_PATIENT_FORM_DATA = 'CLEAR_PATIENT_FORM_DATA';

export const PATIENT_FORMS_SUBMIT_REQUEST = 'PATIENT_FORMS_SUBMIT_REQUEST';
export const PATIENT_FORMS_SUBMIT_CLEAR = 'PATIENT_FORMS_SUBMIT_CLEAR';
export const IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS = 'IS_REFRESH_QUEUE_SUBMITTED_DOCUMENTS';
export const IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL = 'IS_OPEN_UPLOAD_NEW_DOUMENT_MODAL';
export const SELECTED_ACTIVE_TAB='SELECTED_ACTIVE_TAB';
// offline functionality constants
export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING';

export const SET_PATIENT_FORMS_VALIDATION_ERRORS = 'SET_PATIENT_FORMS_VALIDATION_ERRORS';
export const CLEAR_PATIENT_FORMS_VALIDATION_ERRORS = 'CLEAR_PATIENT_FORMS_VALIDATION_ERRORS';
export const SET_PATIENT_FORMS_SAVING= 'SET_PATIENT_FORMS_SAVING';

export const TRIGGER_PATIENT_FORMS_REFRESH = 'TRIGGER_PATIENT_FORMS_REFRESH';

// for prefetch cases
export const SET_SELECTED_PREFETCH_CASES = 'SET_SELECTED_PREFETCH_CASES';
export const REMOVE_SELECTED_PREFETCH_CASE = 'REMOVE_SELECTED_PREFETCH_CASE';

export const IS_SURGEON_FORM_DETAILS = 'IS_SURGEON_FORM_DETAILS';
export const SELECTED_SURGEON_ID = 'SELECTED_SURGEON_ID';
export const SELECTED_SURGEON_NAME = 'SELECTED_SURGEON_NAME';
export const SET_SURGEON_FORMS_DATA = 'SET_SURGEON_FORMS_DATA';
export const CLEAR_SURGEON_FORMS_DATA = 'CLEAR_SURGEON_FORMS_DATA';
export const UPDATE_UNSAVED_ANESTHETIC_INFUSION = 'UPDATE_UNSAVED_ANESTHETIC_INFUSION';
export const CLEAR_UNSAVED_ANESTHETIC_INFUSION = 'CLEAR_UNSAVED_ANESTHETIC_INFUSION';
